import React from 'react'

function Deanery() {
    return (
        <section id='Deanery'>
            <div className="Deanery__container">
                <h3>{'Welcome to AASTMT Deanery of Admission & Registration'}</h3>
                <p>
                The Deanery of Admission and Registration acts as one of the main channels of communication between the students and the AAST. This channel starts as soon as the student is admitted, and continues as long as s/he is studying at AAST, and even after graduation. The Deanery of Admission and Registration acts as one of the main channels of communication between the students and the AAST. This channel starts as soon as the student is admitted, and continues as long as s/he is studying at AAST, and even after graduation.
                </p>
            </div>
        </section>
    )
}

export default Deanery
